import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import api from "../../../api/API_SERVERS";
import Waiting from "./options/Waiting";
import Payday from "./options/Payday";
import Active from "./options/Active";

export default function LoggedIn() {
    const [userStatus, setUserStatus] = useState("");
    const [personId, setPersonId] = useState("");

    const navigate = useNavigate();


    const getUserStatus = async () => {
        try {
            const response = await api.get('/api/teachers/profile');
            const data = response.data.teacher;

            setPersonId(data.person_id);
            setUserStatus(data.status);
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        getUserStatus();
    }, []);

    useEffect(() => {
        if(!localStorage.getItem("teacherToken")) {
            navigate("/")
        }
    })


    return (
        <>
            <div>
                <div>
                    {
                        userStatus === "waiting" && <Waiting personId={personId} />
                    }
                    {
                        userStatus === "passive" && <Payday/>
                    }
                    {
                        userStatus === "active" && <Active personId={personId}/>
                    }
                </div>
            </div>
        </>
    )
}